import { useState, useCallback } from 'react';

import {
  FetchMaterialsSetsCacheKey,
  FetchMaterialsSetByUserIdScopeType
} from '../../../../../materialsSets/materialsSetsTypes';
import { ThreeDStockOnMaterialsSelect } from '../../../../../stock/pages/ThreeDStockMaterials/ThreeDStockMaterials.types';

import {
  FETCH_MATERIALS_SET_BY_USER_ID_QUERY,
  FetchMaterialsSetByUserIdQueryResponse
} from '../../../../../materialsSets/queries/fetchMaterialsSetByUserId.query';

import { useMaterialsSetByUserId } from '../../../../../materialsSets/hooks/useMaterialsSetByUserId';
import { useCurrentUser } from '../../../../../../auth/hooks/useAuth/useAuth';

interface MaterialsIndexPageSelectedMaterialsOptions {
  materialsSetScope?: FetchMaterialsSetByUserIdScopeType;
  materialsSetCacheKey: FetchMaterialsSetsCacheKey;
  onMaterialsSelect?: ThreeDStockOnMaterialsSelect;
}

function useMaterialsIndexPageSelectedMaterials({
  materialsSetScope,
  materialsSetCacheKey,
  onMaterialsSelect
}: MaterialsIndexPageSelectedMaterialsOptions) {
  const currentUser = useCurrentUser();

  const {
    materialsSet,
    materialsSetError,
    materialsSetFetched,
    materialsSetIsPlaceholderData,
    updateMaterialsSetCache
  } = useMaterialsSetByUserId<FetchMaterialsSetByUserIdQueryResponse>({
    cacheKey: materialsSetCacheKey,
    query: FETCH_MATERIALS_SET_BY_USER_ID_QUERY,
    userId: currentUser.get('id'),
    scope: materialsSetScope,
    options: {
      onSuccess: (data) =>
        data?.materialsSetByUserId?.selectedMaterials
          ? onMaterialsSelect?.(data?.materialsSetByUserId?.selectedMaterials)
          : undefined
    }
  });

  const [isSelectedMaterialsSidebarOpen, setIsSelectedMaterialsSidebarOpen] =
    useState(false);

  const handleSelectedMaterialsSidebarOpen = useCallback<() => void>(() => {
    setIsSelectedMaterialsSidebarOpen(true);
  }, [setIsSelectedMaterialsSidebarOpen]);

  const handleSelectedMaterialsSidebarClose = useCallback<() => void>(() => {
    setIsSelectedMaterialsSidebarOpen(false);
  }, [setIsSelectedMaterialsSidebarOpen]);

  return {
    materialsSet,
    materialsSetError,
    materialsSetFetched,
    isOptimisticUpdateData: materialsSet?.optimisticUpdate,
    materialsSetIsPlaceholderData,
    updateMaterialsSetCache,
    isSelectedMaterialsSidebarOpen,
    handleSelectedMaterialsSidebarOpen,
    handleSelectedMaterialsSidebarClose
  };
}

export default useMaterialsIndexPageSelectedMaterials;
